import { SecondaryButton } from '@/app/components/SecondaryButton'
import { ICourse } from '@/types/course'
import { useTranslations } from 'next-intl'
import { NewCourseCard } from './NewCourseCard'
import { NewCourseCardSkeleton } from './NewCourseCardSkeleton'

type CoursesListProps = {
  title: React.ReactNode
  courses: ICourse[]
  loadMore?: () => void
  isLoading?: boolean
  pageSize?: number
} & React.HTMLProps<HTMLDivElement>

export const CoursesList = ({
  title,
  courses,
  loadMore,
  isLoading,
  pageSize = 6,
  ...props
}: CoursesListProps) => {
  const t = useTranslations('Courses')

  return (
    <div className={`flex flex-col gap-4 md:gap-8 ${props.className ?? ''}`}>
      <div className="font-title text-2xl md:text-3xl">{title}</div>
      <div className="grid grid-rows-1 gap-x-8 gap-y-6 sm:grid-cols-2 md:grid-cols-3">
        {courses.map((course) => (
          <NewCourseCard key={course._id} course={course} variant="full" />
        ))}
        {!!isLoading &&
          Array.from({ length: pageSize }).map((_, index) => (
            <NewCourseCardSkeleton key={`skeleton-${index}`} />
          ))}
      </div>
      {loadMore && (
        <div className="mt-4 flex md:mt-0">
          <SecondaryButton
            type="button"
            color="black"
            onClick={loadMore}
            disabled={isLoading}
            className="!outline-mydra-black"
          >
            {t('view_x_more', { count: pageSize })}
          </SecondaryButton>
        </div>
      )}
    </div>
  )
}
